export { default } from './js/CBApricotDxProfile';
